document.addEventListener('DOMContentLoaded', function() {
  const badgeButtons = document.querySelectorAll('.rating-badge-button');
  const revealArea = document.getElementById('ratingReviewReveal');
  
  if (!badgeButtons.length || !revealArea) return; // Exit if elements don't exist
  
  badgeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const reviewId = this.getAttribute('data-review');
      const reviewContent = document.querySelector(`[data-review-content="${reviewId}"]`);
      
      const isActive = this.classList.contains('active');
      
      badgeButtons.forEach(btn => btn.classList.remove('active'));
      
      document.querySelectorAll('.review-content').forEach(content => {
        content.classList.remove('active');
      });
      
      if (isActive) {
        revealArea.classList.remove('active');
      } else {
        this.classList.add('active');
        reviewContent.classList.add('active');
        revealArea.classList.add('active');
      }
    });
  });
});